import React from 'react';
import { trackTabClickSell, trackTabClickBuyback } from '../services/analyticsService';

interface TabNavigationProps {
  activeTab: 'sell' | 'buyback';
  onTabChange: (tab: 'sell' | 'buyback') => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
}) => {
  const handleTabChange = (tab: 'sell' | 'buyback') => {
    if (tab === 'sell' && activeTab !== 'sell') {
      trackTabClickSell();
    } else if (tab === 'buyback' && activeTab !== 'buyback') {
      trackTabClickBuyback();
    }
    onTabChange(tab);
  };

  return (
    <div className="bg-gray-800 rounded-lg p-1.5 sm:p-2 flex gap-1.5 sm:gap-2">
      <button
        onClick={() => handleTabChange('sell')}
        className={`flex-1 px-3 sm:px-4 py-2.5 sm:py-2 rounded-lg font-medium transition-colors min-h-[48px] sm:min-h-[44px] text-sm  ${
          activeTab === 'sell'
            ? 'bg-green-600 text-white active:bg-green-700'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600 active:bg-gray-500'
        }`}
      >
        Sell All
      </button>
      <button
        onClick={() => handleTabChange('buyback')}
        className={`flex-1 px-3 sm:px-4 py-2.5 sm:py-2 rounded-lg font-medium transition-colors min-h-[48px] sm:min-h-[44px] text-sm  ${
          activeTab === 'buyback'
            ? 'bg-blue-600 text-white active:bg-blue-700'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600 active:bg-gray-500'
        }`}
      >
        BuyBack
      </button>
    </div>
  );
};

